import { createFileRoute, redirect } from "@tanstack/react-router";
import { SuggestionsPage } from "@/components/suggestions/suggestions-page";
import {
  mergeAuthorSearch,
  type SuggestionsSearch,
  suggestionsSearchSchema,
} from "@/lib/suggestions";

export const Route = createFileRoute("/_app/_library/suggestions")({
  validateSearch: suggestionsSearchSchema,
  // the former `?authorId=x` link becomes `?author=x` (replacing the history entry)
  beforeLoad: ({ search }) => {
    if (search.authorId) {
      throw redirect({
        to: "/suggestions",
        search: { ...search, author: mergeAuthorSearch(search), authorId: undefined },
        replace: true,
      });
    }
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SuggestionsPage
      search={search}
      onSearchChange={(patch: Partial<SuggestionsSearch>, opts?: { replace?: boolean }) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: opts?.replace })
      }
    />
  );
}
